<!--begin::Header-->
<ng-container *ngIf="extrasNotificationsDropdownStyle === 'light'">
	<div class="d-flex flex-column pt-12 bg-dark-o-5 rounded-top">
		<!--begin::Title-->
		<h4 class="d-flex flex-center">
			<span class="text-dark">Panel de Alertas</span>
		</h4>
		<!--end::Title-->

		<!--begin::Tabs-->
    <ng-container *ngIf="alertList.length > 0; else sinAlertas">
      <ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-primary mt-3 px-8" role="tablist">
        <li class="nav-item">
          <a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('topbar_notifications_events')" [ngClass]="getActiveCSSClasses('topbar_notifications_events')"
          >Alertas <fa-icon *ngIf="unreadAlerts" icon="exclamation" class="fa-xl text-danger alert-icon ml-1 pb-2"></fa-icon><span class="btn btn-text btn-danger btn-sm font-weight-bold btn-font-md ml-2 countAlert">{{ alertList.length }}</span></a
          >
        </li>
      </ul>
    </ng-container>
		<!--end::Tabs-->
	</div>
</ng-container>
<ng-template #sinAlertas>
  <div class="p-4 text-center">
    <h5 class="mb-0" style="font-size: 15px;">Sin alertas
      <i class="fa-solid fa-face-smile" style="color: #4b8fd8;"></i>
    </h5>
  </div>
</ng-template>
<ng-container *ngIf="extrasNotificationsDropdownStyle === 'dark'">
	<div class="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top" style="background-image: url('./assets/media/misc/bg-1.jpg')">
		<!--begin::Title-->
		<h4 class="d-flex flex-center rounded-top">
			<span class="text-white">User Notifications</span>
			<span class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2">23 new</span>
		</h4>
		<!--end::Title-->

		<!--begin::Tabs-->
		<ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-3 px-8" role="tablist">
			<li class="nav-item">
				<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('topbar_notifications_notifications')" [ngClass]="getActiveCSSClasses('topbar_notifications_notifications')">Alerts</a>
			</li>
			<li class="nav-item">
				<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('topbar_notifications_events')" [ngClass]="getActiveCSSClasses('topbar_notifications_events')">Events</a>
			</li>
			<li class="nav-item">
				<a class="nav-link cursor-pointer" data-toggle="tab" (click)="setActiveTabId('topbar_notifications_logs')" [ngClass]="getActiveCSSClasses('topbar_notifications_logs')">Logs</a>
			</li>
		</ul>
		<!--end::Tabs-->
	</div>
</ng-container>
<!--end::Header-->

<!--begin::Content-->
<div class="tab-content">
	<!--begin::Tabpane-->
	<div class="tab-pane p-8" id="topbar_notifications_notifications" role="tabpanel" [ngClass]="getActiveCSSClasses('topbar_notifications_notifications')">
		<!--begin::Scroll-->
		<div class="scroll pr-7 mr-n7 ps" style="position: relative; max-height: 300px" perfectScrollbar>
			<!-- Custom content-->
			<!--Tab pane content loop-->
			<ng-container #tabItem *ngFor="let notifItem of notificationItems | slice : 0 : 50; let i = index">
				<div class="d-flex align-items-center mb-6">
					<!-- symbol in item-->
					<div class="symbol symbol-40 mr-5" [ngClass]="notifItem.itemSymbolClass">
						<span class="symbol-label">
							<span [inlineSVG]="notifItem.itemSvg" cacheSVG="true" class="svg-icon svg-icon-xl svg-icon-primary" [ngClass]="notifItem.itemIconClass"></span>
						</span>
					</div>
					<!--text in item-->
					<div class="d-flex flex-column font-weight-bold">
						<a href="" [routerLink]="'/' + notifItem.link" class="text-dark text-hover-primary mb-1 font-size-lg">{{ notifItem.title }}</a>
						<span class="text-muted">{{ notifItem.message }}</span>
					</div>
				</div>
			</ng-container>
		</div>
		<!--end::Scroll-->

		<!--begin::Action-->
		<!-- <div class="d-flex flex-center pt-7">
      <a href="#" class="btn btn-light-primary font-weight-bold text-center"
        >Ver más</a
      >
    </div> -->
		<!--end::Action-->
	</div>
	<!--end::Tabpane-->

	<!--begin::Tabpane-->
	<div class="tab-pane" id="topbar_notifications_events" role="tabpanel" [ngClass]="getActiveCSSClasses('topbar_notifications_events')">
		<!--begin::Scroll-->
		<div class="scroll pr-0 mx-5 ps" style="position: relative; max-height: 300px" perfectScrollbar>
			<!-- container for spinner if waiting-->
			<ng-container *ngIf="waitingAlerts$ | async">
				<div class="row my-5">
					<div class="offset-5 col-1">
						<span class="spinner spinner-primary spinner-lg ml-5"></span>
					</div>
				</div>
			</ng-container>
      <ng-container *ngIf="alertList.length > 0">
        <div class="d-flex justify-content-end mb-4">
          <button 
            class="btn btn-primary btn-sm font-weight-bold marcarLeidas" 
            (click)="markAllAsSeen()" 
            [disabled]="isMarkingAllAsRead">
            <span *ngIf="isMarkingAllAsRead" class="spinner-border spinner-border-sm mr-2" role="status"></span>
            Marcar todas como leídas
          </button>
        </div>
      </ng-container>
      
			<!-- container for alert list-->
			<ng-container *ngIf="alertList && alertList.length > 0">
				<ng-container *ngFor="let alert of alertList; let i = index">
					<div *ngIf="i > 0" class="separator separator-solid"></div>

					<div class="d-flex flex-column align-items-left mb-6 mt-2">
						<div class="d-flex flex-row font-weight-bold">
							<!-- symbol in item-->
							<div class="symbol symbol-40 mr-5" [ngClass]="'symbol-light-danger'">
								<span class="symbol-label">
									<span title="" [inlineSVG]="'assets/media/svg/icons/General/Attachment2.svg'" cacheSVG="true" class="svg-icon svg-icon-xl svg-icon-primary" [ngClass]="'svg-icon-danger'"></span>
								</span>
							</div>

							<!-- title in item-->
							<a [routerLink]="" class="text-dark text-hover-primary mb-1 font-size-lg">{{ alert.titulo }}</a>
						</div>
						<div class="d-flex flex-row align-items-center font-weight-bold">
							<!--text in item-->

							<span class="text-muted pr-5">{{ alert.mensaje }}</span>
							<ng-container *ngIf="alert.pidiendoLectura">
								<ng-container *ngIf="waitForReadRequestAlert$ | async">
									<div class="my-5 pr-10">
										<span class="spinner spinner-primary spinner-lg"></span>
									</div>
								</ng-container>
							</ng-container>
							<ng-container *ngIf="!alert.pidiendoLectura">
								<ng-container *ngIf="!(waitForReadRequestAlert$ | async)">
									<a *ngIf="!alert.leida" [routerLink]="" (click)="markAsSeen(alert, i)" class="symbol symbol-30 seen-button" [ngClass]="'symbol-light-primary'">
										<span class="symbol-label">
											<span title="Leído" [inlineSVG]="'assets/media/svg/icons/General/Visible.svg'" cacheSVG="true" class="svg-icon svg-icon-lg svg-icon-primary" [ngClass]="'svg-icon-primary'"></span>
										</span>
									</a>
								</ng-container>
							</ng-container>
						</div>
						<div class="d-flex flex-row align-items-left">
							<span class="text-muted badge badge-pill badge-secondary my-2 float-left">{{ alert.dateToShow }}</span>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<!--end::Scroll-->
	</div>
  

	<!--end::Tabpane-->

	<!--begin::Tabpane-->
	<!-- <div
    class="tab-pane"
    id="topbar_notifications_events"
    role="tabpanel"
    [ngClass]="getActiveCSSClasses('topbar_notifications_events')"
  > -->
	<!--begin::Nav-->
	<!-- <div
      class="navi navi-hover scroll my-4"
      data-scroll="true"
      style="position: relative; max-height: 300px;"
      perfectScrollbar
    > -->
	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-line-chart text-success"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New report has been received
            </div>
            <div class="text-muted">
              23 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-paper-plane text-danger"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              Finance report has been generated
            </div>
            <div class="text-muted">
              25 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-user flaticon2-line- text-success"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New order has been received
            </div>
            <div class="text-muted">
              2 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-pin text-primary"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New customer is registered
            </div>
            <div class="text-muted">
              3 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-sms text-danger"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              Application has been approved
            </div>
            <div class="text-muted">
              3 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-pie-chart-3 text-warning"></i>
          </div>
          <div class="navinavinavi-text">
            <div class="font-weight-bold">
              New file has been uploaded
            </div>
            <div class="text-muted">
              5 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon-pie-chart-1 text-info"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New user feedback received
            </div>
            <div class="text-muted">
              8 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-settings text-success"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              System reboot has been successfully completed
            </div>
            <div class="text-muted">
              12 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon-safe-shield-protection text-primary"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New order has been placed
            </div>
            <div class="text-muted">
              15 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-notification text-primary"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              Company meeting canceled
            </div>
            <div class="text-muted">
              19 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-fax text-success"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New report has been received
            </div>
            <div class="text-muted">
              23 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon-download-1 text-danger"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              Finance report has been generated
            </div>
            <div class="text-muted">
              25 hrs ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon-security text-warning"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New customer comment recieved
            </div>
            <div class="text-muted">
              2 days ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->

	<!--begin::Item-->
	<!-- <a href="#" class="navi-item">
        <div class="navi-link">
          <div class="navi-icon mr-2">
            <i class="flaticon2-analytics-1 text-success"></i>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              New customer is registered
            </div>
            <div class="text-muted">
              3 days ago
            </div>
          </div>
        </div>
      </a> -->
	<!--end::Item-->
	<!-- </div> -->
	<!--end::Nav-->

	<!-- </div> -->

	<!--end::Tabpane-->

	<!--begin::Tabpane-->
	<!-- <div
    class="tab-pane"
    id="topbar_notifications_logs"
    role="tabpanel"
    [ngClass]="getActiveCSSClasses('topbar_notifications_logs')"
  > -->
	<!--begin::Nav-->
	<!-- <div class="d-flex flex-center text-center text-muted min-h-200px">
      All caught up!
      <br />
      No new notifications.
    </div> -->
	<!--end::Nav-->
	<!-- </div> -->
	<!--end::Tabpane-->
</div>
<!--end::Content
<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>-->